import { z } from 'zod'

export const ConfigurationTransportRequestContraintsZod = z.object({
  customerDistanceFromOriginThresholdInMeters: z.number(),
})
